import { Container, Stack, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  AuthenticationContentStyle,
  AuthenticationStyle,
} from 'src/components/authentication/AuthenticationStyles';
import SignInForm from 'src/containers/authentication/SignInForm';
import { useAppDispatch, useAppSelector } from 'src/hooks/store';
import { resetError } from 'src/slices/auth';
import { AuthSocial } from '../components/authentication/';
import { APP_NAME } from '../constants/global';

export const SignIn: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const error = useAppSelector((state) => state.auth.error);
  useEffect(() => {
    if (error === 'accountDisabled') {
      navigate('/accountNotActivated');
      dispatch(resetError());
    }
  }, [error]);
  return (
    <AuthenticationStyle title={`SignIn | ${APP_NAME}`}>
      <Container sx={{ maxWidth: '400px' }}>
        <AuthenticationContentStyle>
          <Stack sx={{ mb: 5 }}>
            <Typography variant="h4" gutterBottom>
              {t('pages.SignIn.signIn')}
            </Typography>
            <Typography sx={{ color: 'text.secondary' }}>
              {t('pages.SignIn.enterDetails')}
            </Typography>
          </Stack>
          <AuthSocial />
          <SignInForm />
        </AuthenticationContentStyle>
      </Container>
    </AuthenticationStyle>
  );
};
